/** Trading currency. Luce prices in SGD only — no conversion is performed. */
export const currencyCode = "SGD";

/** Symbol prefixed by {@link formatPrice}. */
export const currencySymbol = "$";

/** Default decimal places for a displayed price. */
export const currencyDecimals = 2;
